module.exports = __webpack_public_path__ + "static/media/reload.aca5f0f7.svg";